(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-provider-card/prescript.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-provider-card/prescript.js');

svs = svs || {};
svs.components = svs.components || {};
svs.components.casino_react = svs.components.casino_react || {};
svs.components.casino_react.casioProviderCard = svs.components.casino_react.casioProviderCard || {};

var mockImage = {
  typeName: 'c_8539204948786',
  width: 640,
  height: 360,
  altText: 'thunderkick',
  title: 'Thunderkick Logotype',
  url: '/cms/images/46f2430a-fdf7-4642-bdcd-cc79c0abb4b6/c_8539204948786/8afbb1da-73fe-436e-82b6-c85ec0ff9ed5/1.0/thunderkick-logo-white-1000x560-{width}.png',
  originalImage: false,
  availableWidths: [
    320,
    480,
    640
  ],
  availableFormats: [
    {
      mimetype: 'image/webp',
      extension: '.webp'
    },
    {
      mimetype: 'image/png',
      extension: '.png'
    }
  ],
  versionLabel: '1.0'
};
svs.casino_react = svs.casino_react || {};
svs.casino_react.shared = svs.casino_react.shared || {};
svs.casino_react.shared.data = svs.casino_react.shared.data || {};
svs.casino_react.shared.data.cmsProviderList = svs.casino_react.shared.data.cmsProviderList || [{
  model: {
    systemName: 'thunderkick',
    provider: 'Thunderkick',
    logoImage: mockImage
  }
}];


 })(window);